// extracted by mini-css-extract-plugin
module.exports = {"bookmarkInput":"BookmarkMenu-module__bookmarkInput___1bhFv","importInput":"BookmarkMenu-module__importInput___2EGUD"};